module.exports = __webpack_public_path__ + "images/emoji/roller_coaster.43409f057d7b473a6ecb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/roller_coaster.png
// module id = Rrdg
// module chunks = 13